<template>
	<div class="prdClassify">
		<div class="title">产品推广分类</div>
		<el-row class="filter" :gutter="20">
			<el-col :span="4">
				<sky-select
					v-model="selValue"
					:options="options"
					@change="change"
					:clearable="false"
					size="small"
				></sky-select
			></el-col>
			<el-col :span="4"
				><sky-select
					v-model="two_selValue"
					:options="two_options"
					@change="two_change"
					size="small"
					v-if="two_select"
					:props="props"
				></sky-select
			></el-col>
		</el-row>
		<div v-loading="loading">
			<div class="choice_box" v-if="classifyData.length">
				<classifyChoice
					:value="value"
					v-bind="item"
					v-for="(item, index) in classifyData"
					:key="index"
					@check="checkChange"
				></classifyChoice>
			</div>
			<div class="choice_box info" v-else>
				<img src="../../../assets/empty_images/zanwushuju.png" />
				<div>暂无数据</div>
			</div>
		</div>
	</div>
</template>
<script>
import skySelect from '@/components/iglobalwin/formComponents/sky-select.vue';
import adsNewOnline from '@/backend/services/adsNewOnline/adsNewOnlineSer.js';
import classifyChoice from '@/components/adsOnlineAuto/com/classifyChoice';
export default {
	props: {
		value: null,
	},
	data() {
		return {
			selValue: '0',
			options: [
				{
					value: '0',
					label: '全部分类',
				},
				{
					value: '1',
					label: '一级分类',
				},
				{
					value: '2',
					label: '二级分类',
				},
				{
					value: '3',
					label: '三级分类',
				},
			],
			two_select: false,
			two_options: [],
			oneClassify: [],
			twoClassify: [],
			threeClassify: [],
			props: {
				label: 'name',
				value: 'id',
			},
			two_selValue: '',
			classifyData: [],
			allData: [],
			choose: [],
			otherData: [],
			loading: false,
		};
	},
	components: { skySelect, classifyChoice },
	computed: {
		queryParam() {
			return this.$route.query;
		},
	},
	watch: {
		value: {
			handler(val) {
				this.choose = val;
			},
			deep: true,
			immediate: true,
		},
	},
	methods: {
		change(val) {
			if (val == '0') {
				this.classifyData = this.allData;
				this.two_select = false;
			}
			if (val == '1') {
				this.classifyData = this.oneClassify;
				this.two_select = false;
			}
			if (val == '2') {
				this.two_options = this.oneClassify;
				this.classifyData = this.twoClassify;
				this.two_select = true;
			}
			if (val == '3') {
				this.two_options = this.twoClassify;
				this.classifyData = this.threeClassify;
				this.two_select = true;
			}
		},
		two_change(val) {
			if (val) {
				this.classifyData = this.allData.filter(e => {
					return e.pid === val;
				});
			} else {
				if (this.selValue == '2') {
					this.classifyData = this.twoClassify;
				}
				if (this.selValue == '3') {
					this.classifyData = this.threeClassify;
				}
			}
		},
		checkChange(obj) {
			let flag = this.choose.some(item => {
				return obj.productTypeId == item.productTypeId;
			});
			if (flag) {
				this.choose = this.choose.filter(function (ele) {
					return ele.productTypeId != obj.productTypeId;
				});
			} else {
				this.choose.push(obj);
			}
			this.$emit('input', this.choose);
		},
		async getData() {
			try {
				this.loading = true;
				let res = await adsNewOnline.classifyList({ siteid: this.queryParam.projectId });
				this.loading = false;
				this.allData = res.data;
				this.classifyData = this.allData;
				this.oneClassify = this.allData.filter(e => {
					return e.pid === '0';
				});
				this.otherData = this.allData.filter(e => {
					return e.pid != '0';
				});
				this.oneClassify.forEach(query => {
					this.otherData.forEach(item => {
						if (query.id === item.pid) {
							this.twoClassify.push(item);
						}
					});
				});
				this.twoClassify.forEach(query => {
					this.otherData.forEach(item => {
						if (query.id === item.pid) {
							this.threeClassify.push(item);
						}
					});
				});
			} catch (error) {
				this.loading = false;
			}
		},
	},
	mounted() {
		this.getData();
	},
};
</script>

<style lang="scss" scoped>
.prdClassify {
	.title {
		font-size: 16px;
		font-weight: bold;
		color: rgba(0, 0, 0, 0.85);
	}
	.filter {
		margin: 30px 0px;
	}
	.choice_box {
		display: grid;
		grid-template-columns: repeat(5, 18.5%);
		gap: 20px;
	}
	.info {
		padding: 30px;
		font-size: 15px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;

		img {
			width: 280px;
		}

		div {
			font-size: 15px;
			font-weight: 400;
			color: #666666;
			line-height: 21px;
		}
	}
}
</style>
